import type { NodeType } from './types';

export const nodeWidth: Record<NodeType, number> = {
  action: 256,
  decision: 256,
  start: 100,
  end: 100,
};

export const nodeHeight: Record<NodeType, number> = {
  action: 98,
  decision: 98,
  start: 32,
  end: 32,
};
